(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/start.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.Start = Marionette.View.extend({
    template: function template(data) {
      if (this.model.get('isCustomerRegistration')) {
        return svs.player_login.templates.player_registration(data);
      }

      return svs.player_login.templates.start(data);
    },
    behaviors: function behaviors() {
      var behaviors = [{
        behaviorClass: svs.player_login.behaviors.AboutBankid
      }, {
        behaviorClass: svs.player_login.behaviors.TabHandler
      }];

      if (!this.options.model.get('hideUsernameLogin')) {
        behaviors.push({
          behaviorClass: svs.player_login.behaviors.UsernameLogin
        });
      }

      return behaviors;
    },
    ui: {
      bankidSameDeviceLoginBtn: '.js-bankid-login',
      bankidOtherDeviceBtn: '.js-bankid-login-other-device',
      cancelLoginButton: '.js-cancel-login',
      frejaeidSameDeviceLoginBtn: '.js-frejaeid-login',
      frejaeidOtherDeviceBtn: '.js-frejaeid-login-other-device',
      cancelFrejaeidLoginButton: '.js-frejaeid-cancel-login',
      navigateToCustomerRegistration: '.js-sign-up',
      navigateToCustomerLogin: '.js-login-link'
    },
    events: {
      'click @ui.bankidSameDeviceLoginBtn': 'onBankIdSameDeviceClick',
      'click @ui.bankidOtherDeviceBtn': 'onBankIdOtherDeviceClick',
      'click @ui.cancelLoginButton': 'onCancelLoginClick',
      'click @ui.frejaeidSameDeviceLoginBtn': 'onFrejaEidSameDeviceClick',
      'click @ui.frejaeidOtherDeviceBtn': 'onFrejaEidOtherDeviceClick',
      'click @ui.cancelFrejaeidLoginButton': 'onCancelFreajEidLoginClick',
      'click @ui.navigateToCustomerRegistration': 'onNavigateToCustomerRegistration',
      'click @ui.navigateToCustomerLogin': 'onNavigateToCustomerLogin'
    },
    onAttach: function onAttach() {
      if (!this.model.get('isCustomerRegistration')) {
        if (this.model.get('currentTab') === 'frejaeid' && svs.core.detect.formfactor.desktop() && !this.model.get('isTabletDevice') && !svs.core.detect.touch()) {
          this.model.set('otherFrejaDevice', true);
          this.startFrejaQRCodeLogin();
        }
      }
    },
    onBankIdSameDeviceClick: function onBankIdSameDeviceClick() {
      this.model.set('startBankId', true);
      this.model.set('isSsnLogin', false);
      this.model.set('sameDevice', true);
      svs.player_login.router.navigate("/bankid?".concat(this.model.toQueryString('bankid')), true);
    },
    onBankIdOtherDeviceClick: function onBankIdOtherDeviceClick() {
      var _this = this;

      var logger = svs.core.log.getLogger('module:player-login');
      this.model.set('sameDevice', false); 

      svs.core.deviceSession.get('bankIdLoginMethod', 'customer_login', function (result, err) {
        if (err) {
          logger.debug('Error when getting bankid login method from device session.');
        }

        _this.model.set('isSsnLogin', (result || 'qr') === 'ssn'); 


        if (_this.model.get('isSsnLogin')) {
          _this.model.set('startBankId', false);

          svs.player_login.router.navigate("/mobilt-bankid?".concat(_this.model.toQueryString('bankid')), true);
        } else {
          _this.model.set('startBankId', false);

          svs.player_login.router.navigate("/bankid?".concat(_this.model.toQueryString('bankid')), true);
        }
      });
    },
    onCancelLoginClick: function onCancelLoginClick(e) {
      e.preventDefault();
      svs.utils.url.navigate(this.model.get('cancelUrl') || svs.utils.urlMapping.get('startPage'));
    },
    onFrejaEidSameDeviceClick: function onFrejaEidSameDeviceClick() {
      this.model.set('otherFrejaDevice', false);
      svs.player_login.router.navigate("/frejaeid?".concat(this.model.toQueryString('frejaeid')), true);
    },
    onFrejaEidOtherDeviceClick: function onFrejaEidOtherDeviceClick(e) {
      e.preventDefault();
      this.startFrejaQRCodeLogin();
    },
    onCancelFreajEidLoginClick: function onCancelFreajEidLoginClick(e) {
      e.preventDefault();
      svs.utils.url.navigate(this.model.get('cancelUrl') || svs.utils.urlMapping.get('startPage'));
    },
    onNavigateToCustomerRegistration: function onNavigateToCustomerRegistration(e) {
      e.preventDefault();
      svs.utils.url.navigate("".concat(svs.utils.urlMapping.get('customerRegistrationHome'), "?").concat(this.model.toQueryString()));
    },
    onNavigateToCustomerLogin: function onNavigateToCustomerLogin(e) {
      e.preventDefault();
      svs.utils.url.navigate("".concat(svs.utils.urlMapping.get('loginHome'), "?").concat(this.model.toQueryString()));
    },
    startFrejaQRCodeLogin: function startFrejaQRCodeLogin() {
      var _this2 = this;

      svs.player_login.radio.request('authRef').done(function (authRef) {
        _this2.model.set('authRef', authRef);

        _this2.model.set('otherFrejaDevice', true);

        _this2.model.set('startFrejaEid', false);

        svs.player_login.router.navigate("frejaeidpoll?".concat(_this2.model.toQueryString('frejaeid')), true);
      }).fail(function (err) {
        _this2.triggerMethod('frejaEidError', err);
      });
    }
  });
})(Backbone, _, svs);
 })(window);